

import  { useEffect, useState } from "react";
import { CommonHeader } from "../../../components/commons";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import TdsMasterListing from "../../../components/MasterData/TdsMaster/TdsTcsMaster/TdsMasterListing";
import TcsMasterListing from "../../../components/MasterData/TdsMaster/TdsTcsMaster/TcsMasterListing";


type TabsType = {
  name: string;
  label: string;
  display: boolean | undefined;
};
const tabs: TabsType[] = [
  {
    name: "TDS Master",
    label: "tds_master",
    display: false,
  },
  {
    name: "TCS Master",
    label: "tcs_master",
    display: false,
  },
];
type AppProps = {
  history?: any;
};
const TdsAndTcsMaster = ({ history }: AppProps) => {
  const persistActivetab = history?.location?.state?.activeTab;

  const [finalTab, setFinalTab] = useState(tabs);


  //====================User Management=============================
  const [isAddTdsPresent, setIsAddTdsPresent] = useMenuCheck();
  const [isAddTcsPresent, setIsAddTcsPresent] = useMenuCheck();

  const [isGetTdsListPresent, setIsGetTdsListPresent] =
    useMenuCheck("tds");
  const [isGetTcsListPresent, setIsGetTcsListPresent] =
    useMenuCheck("tcs");
  
  //=================================================================
  const [activeTab, setActiveTab] = useState(
    persistActivetab ? persistActivetab : tabs[0]?.label
  );

  useEffect(()=>{
    setIsAddTdsPresent("Add TDS Master", "menu")
    setIsAddTcsPresent("Add TCS", "menu")
    setIsGetTdsListPresent("Get TDS Listing", "menu")
    setIsGetTcsListPresent("Get TCS Listing", "menu")

  
  
  },[])

  // FUTURE USE
  useEffect(()=>{
    if(isGetTdsListPresent && !isGetTcsListPresent){
      setFinalTab([tabs[0]])
      setActiveTab(tabs[0]?.label)
    } else if (isGetTcsListPresent && !isGetTdsListPresent){
      setFinalTab([tabs[1]])
      setActiveTab(tabs[1]?.label)

    }
    else if(!isGetTdsListPresent && !isGetTcsListPresent){
      setFinalTab([])
    }
    else {
      setFinalTab([...tabs])
    }
  },[isGetTdsListPresent,isGetTcsListPresent])

  useEffect(() => {
    if (persistActivetab) {
      setActiveTab(persistActivetab);
    }
  }, [persistActivetab]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
    delete history?.location?.state?.searchValue
    delete history?.location?.state?.sortBy

  };
  const renderTabs = () => {
    const finalTabs = finalTab?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className={tab.display ? "tab-style mr-4 pointer" : "pointer"}
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 16px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "16px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTabs;
  };
  const activeTabRender = () => {
    switch (activeTab) {
      case "tds_master":
        return (
          <TdsMasterListing
            activeTab={activeTab}
            history={history}
            isAddTdsPresent={isAddTdsPresent}
            isGetTdsListPresent={isGetTdsListPresent}

          />
        );
      case "tcs_master":
        return (
          <TcsMasterListing
            activeTab={activeTab}
            history={history}
            isAddTcsPresent={isAddTcsPresent}
            isGetTcsListPresent={isGetTcsListPresent}

          />
        );

      default:
        return (
          <TdsMasterListing
          activeTab={activeTab}
          history={history}
          isAddTdsPresent={isAddTdsPresent}
          isGetTdsListPresent={isGetTdsListPresent}


        />
        );
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="TDS And TCS" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>
            <div>
              <div className="d-flex flex-row justify-content-end">
                {activeTab == "tds_master" && isAddTdsPresent ? (
                  <button
                    style={{ fontSize: "14px", padding: "9px" }}
                    className="btn btn-primary"
                    onClick={()=> 
                      history.push({
                        pathname: "/master-data/tds-and-tcs-master/add-tds",
                        state: { 
                          activeTab},
                      })
                    }
                  >
                    {activeTab == "tds_master" ? <span>+ Add TDS</span> : ""}
                  </button>
                ) : (
                  ""
                )}
                {activeTab == "tcs_master"  && isAddTcsPresent? (
                  <button
                    style={{ fontSize: "14px", padding: "9px" }}
                    className="btn btn-primary"
                    onClick={()=>history.push({
                        pathname: "/master-data/tds-and-tcs-master/add-tcs",
                        state: { 
                          activeTab},
                      })
                    }
                  >
                    {activeTab == "tcs_master" ? (
                      <span>+ Add TCS</span>
                    ) : (
                      ""
                    )}
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }}>
          {activeTabRender()}
        </div>
      </div>
    </>
  );
};

export default TdsAndTcsMaster;

